<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
  <path fill="#fff" fill-rule="nonzero"
        d="M7.94 3.18a.901.901 0 0 0-1.44.72v16.2a.901.901 0 0 0 1.44.72l10.8-8.1a.898.898 0 0 0 0-1.44l-10.8-8.1z"/>
</svg>
